export const SITE_URL = 'https://obozy.org.pl'
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`
export const DEFAULT_OG_IMAGE_ALT =
  'Obozy - Gra Terenowa - Uczestnicy w lesie podczas intensywnej gry terenowej'
export const OG_IMAGE_WIDTH = '1200'
export const OG_IMAGE_HEIGHT = '630'
